import ChatIconWithCount from '@/components/chat/ChatIconWIthCount'
import { SiteHeader } from '@/components/site-header'
import SponsorshipData from '@/components/sponsorship/SponsorshipData'
import { PATHROUTES } from '@/constants/path'
import { useUnreadMessages } from '@/hooks/useUnreadMessages'
import { tokenService } from '@/lib/token.service'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

function SponsorshipManagement() {
  const [searchQuery, setSearchQuery] = useState('')
  const navigate = useNavigate()
  const user = tokenService.getUser()
  const { unreadCount } = useUnreadMessages(user.id)

  const handleSearchChange = (value: string) => {
    setSearchQuery(value)
  }

  const handleMessageAdminClick = () => {
    navigate(PATHROUTES.DASHBOARD.MESSAGE_ADMIN)
  }

  return (
    <main
      className="@container/main flex flex-1 flex-col"
      id="main-content"
      tabIndex={-1}
      aria-label="Sponsorship Main Content"
    >
      <section
        aria-label="Sponsorship Header and Actions"
        className="flex flex-col gap-4 md:gap-6"
      >
        <SiteHeader
          title="Sponsorship"
          subtitle="Choose your sponsorship tier and ad placements. Payment is required before uploading ads."
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          showSearch={false}
        />
      </section>

      <ChatIconWithCount
        count={unreadCount}
        handleClick={handleMessageAdminClick}
      />

      <section aria-label="Sponsorship Data" className="mt-2">
        <SponsorshipData />
      </section>
    </main>
  )
}

export default SponsorshipManagement
